import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { ReactNode } from 'react';
import styles from './PageIntro.module.scss';
export type PageIntroAlign = 'start' | 'center';
export type PageIntroSubtitleAs = 'div' | 'h2' | 'h3' | 'p';
export type PageIntroSubtitleMobileScale = 'default' | 'display';
export type PageIntroSubtitleScale = 'body' | 'lead';
export type PageIntroSubtitleSpacing = 'default' | 'loose';
export type PageIntroSubtitleVariant = 'heading' | 'body';
export type PageIntroTitleScale = 'lg' | 'xl';

/**
 * A page's intro: the title, its meta and subtitle, then any children. It
 * keeps 80px under it for the copy that follows it in its column; as the
 * last block of its section it keeps none, so the section's boundary is the
 * section rhythm's alone.
 */
export interface PageIntroProps {
  align?: PageIntroAlign;
  children?: ReactNode;
  meta?: ReactNode;
  subtitle?: ReactNode;
  subtitleAs?: PageIntroSubtitleAs;
  subtitleMobileScale?: PageIntroSubtitleMobileScale;
  subtitleScale?: PageIntroSubtitleScale;
  subtitleSpacing?: PageIntroSubtitleSpacing;
  subtitleVariant?: PageIntroSubtitleVariant;
  title?: ReactNode;
  titleScale?: PageIntroTitleScale;
}
function PageIntro(t0) {
  const $ = _c(32);
  const {
    align: t1,
    children,
    meta,
    subtitle,
    subtitleAs,
    subtitleMobileScale: t2,
    subtitleScale: t3,
    subtitleSpacing: t4,
    subtitleVariant: t5,
    title,
    titleScale: t6
  } = t0;
  const align = t1 === undefined ? "start" : t1;
  const subtitleMobileScale = t2 === undefined ? "default" : t2;
  const subtitleScale = t3 === undefined ? "lead" : t3;
  const subtitleSpacing = t4 === undefined ? "default" : t4;
  const subtitleVariant = t5 === undefined ? "heading" : t5;
  const titleScale = t6 === undefined ? "xl" : t6;
  const resolvedSubtitleAs = subtitleAs ?? (subtitleVariant === "body" ? "div" : "h2");
  const Subtitle = resolvedSubtitleAs;
  const t7 = styles[`helios-page-intro__subtitle--${subtitleVariant}`];
  const t8 = styles[`helios-page-intro__subtitle--as-${resolvedSubtitleAs}`];
  const t9 = styles[`helios-page-intro__subtitle--mobile-${subtitleMobileScale}`];
  const t10 = styles[`helios-page-intro__subtitle--spacing-${subtitleSpacing}`];
  const t11 = styles[`helios-page-intro__subtitle--scale-${subtitleScale}`];
  const t12 = subtitleVariant === "body";
  const t13 = subtitleVariant === "body" && align === "center";
  let t14;
  if ($[0] !== t10 || $[1] !== t11 || $[2] !== t12 || $[3] !== t13 || $[4] !== t7 || $[5] !== t8 || $[6] !== t9) {
    t14 = classNames(styles["helios-page-intro__subtitle"], t7, t8, t9, t10, {
      [t11]: t12,
      [styles["helios-page-intro__subtitle--center"]]: t13
    });
    $[0] = t10;
    $[1] = t11;
    $[2] = t12;
    $[3] = t13;
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
    $[7] = t14;
  } else {
    t14 = $[7];
  }
  const subtitleClassName = t14;
  const t15 = styles[`helios-page-intro__title--${titleScale}`];
  let t16;
  if ($[8] !== meta || $[9] !== t15) {
    t16 = classNames(styles["helios-page-intro__title"], t15, {
      [styles["helios-page-intro__title--with-meta"]]: meta
    });
    $[8] = meta;
    $[9] = t15;
    $[10] = t16;
  } else {
    t16 = $[10];
  }
  const titleClassName = t16;
  const t17 = align === "center";
  let t18;
  if ($[11] !== t17) {
    t18 = classNames(styles["helios-page-intro__inner"], {
      [styles["helios-page-intro__inner--center"]]: t17
    });
    $[11] = t17;
    $[12] = t18;
  } else {
    t18 = $[12];
  }
  let t19;
  if ($[13] !== title || $[14] !== titleClassName) {
    t19 = title ? <h1 className={titleClassName}>{title}</h1> : null;
    $[13] = title;
    $[14] = titleClassName;
    $[15] = t19;
  } else {
    t19 = $[15];
  }
  let t20;
  if ($[16] !== meta) {
    t20 = meta ? <div className={styles["helios-page-intro__meta"]}>{meta}</div> : null;
    $[16] = meta;
    $[17] = t20;
  } else {
    t20 = $[17];
  }
  let t21;
  if ($[18] !== subtitle || $[19] !== subtitleSpacing) {
    t21 = subtitle && subtitleSpacing === "loose" ? <br /> : null;
    $[18] = subtitle;
    $[19] = subtitleSpacing;
    $[20] = t21;
  } else {
    t21 = $[20];
  }
  let t22;
  if ($[21] !== Subtitle || $[22] !== subtitle || $[23] !== subtitleClassName) {
    t22 = subtitle ? <Subtitle className={subtitleClassName || undefined}>{subtitle}</Subtitle> : null;
    $[21] = Subtitle;
    $[22] = subtitle;
    $[23] = subtitleClassName;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  if ($[25] !== children || $[26] !== t18 || $[27] !== t19 || $[28] !== t20 || $[29] !== t21 || $[30] !== t22) {
    t23 = <div className={styles["helios-page-intro"]}><div className={t18}>{t19}{t20}{t21}{t22}{children}</div></div>;
    $[25] = children;
    $[26] = t18;
    $[27] = t19;
    $[28] = t20;
    $[29] = t21;
    $[30] = t22;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  return t23;
}
export default PageIntro;